import React from 'react';
import { Routes, Route } from 'react-router-dom';
import styles from './products.module.scss';
import ListProducts from './list';
import DetailProduct from './detail';

const Products = () => (
  <div className={styles.products}>
    <Routes>
      <Route path='/' element={<ListProducts />} />
      <Route path='/:id' element={<DetailProduct />} />
    </Routes>
  </div>
);

export default Products;
